"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.modalidadesAdicionales = exports.modalidadesExportacion = void 0;
exports.modalidadesExportacion = {
    "1": { nombre: "Régimen General", sigla: "1" },
    "2": { nombre: "Consignación", sigla: "2" },
    "3": { nombre: "Precio Revisable", sigla: "3" },
    "4": {
        nombre: "Bienes propios a exclaves aduaneros",
        sigla: "4"
    },
    "90": {
        nombre: "Régimen general exportación de servicios",
        sigla: "90"
    },
    "99": { nombre: "Otras transacciones", sigla: "99" }
};
exports.modalidadesAdicionales = {
    "1": { nombre: "Régimen General", sigla: "1" },
    "2": { nombre: "Consignación", sigla: "2" },
    "3": { nombre: "Precio Revisable", sigla: "3" },
    "4": {
        nombre: "Bienes propios a exclaves aduaneros",
        sigla: "4"
    },
    "80": {
        nombre: "Tax Fre",
        sigla: "80"
    },
    "90": {
        nombre: "Régimen general exportación de servicios",
        sigla: "90"
    },
    "99": { nombre: "Otras transacciones", sigla: "99" }
};
